import { takeEvery, put, call, select, takeLatest } from 'redux-saga/effects'
import featureToggles from 'shared/featureToggles'

import { indicateProgress } from 'api'
import { getRecaptchaToken } from 'shared/recaptcha'

import { userSelector } from 'auth/selectors'
import { getCurrentUserSaga } from 'auth/sagas'
import { setAuthenticatedUser } from 'auth/actions'

import { DELETE_ACCOUNT, UPDATE_ACCOUNT } from 'dashboard-account/constants'
import * as grsApi from 'dashboard-account/grsApi'
import * as nAmApi from 'dashboard-account/nAmApi'
import { sendFeedback } from 'wordpress/api'
import { preferredLocaleSelector } from 'wordpress/selectors'

export function* updateAccountSaga({ details }) {
    try {
        yield indicateProgress(['updateAccount'], function* () {
            const {
                token,
                name,
                details: { dateAdded },
                accountKey,
            } = yield select(userSelector)

            const currentLocale = yield select(preferredLocaleSelector)

            if (featureToggles.newAuthFlow) {
                yield call(
                    nAmApi.updateAccount,
                    token,
                    accountKey,
                    name,
                    dateAdded,
                    details,
                    currentLocale.toUpperCase()
                )
                yield getCurrentUserSaga()
            } else {
                const recaptchaToken = yield call(getRecaptchaToken)
                const user = yield call(grsApi.updateAccount, token, details, recaptchaToken)
                yield put(setAuthenticatedUser(user))
            }
        })
    } catch (e) {}
}

export function* deleteAccountSaga({ reason }) {
    const { email, accountId, accountKey, details } = yield select(userSelector)
    yield call(sendFeedback, {
        firstname: details.firstName,
        lastname: details.lastName,
        accountID: featureToggles.caPurchaseFlow ? accountKey : accountId,
        emailType: DELETE_ACCOUNT,
        email,
        subject: 'Account Deletion Request - URGENT ATTENTION REQUIRED',
        message: reason,
        labels: {
            firstname: 'First name',
            lastname: 'Last name',
            accountID: 'Account ID',
            email: 'Email',
            subject: 'Subject',
            message: 'Deletion Reason',
        },
    })
}

export default function* () {
    yield takeEvery(UPDATE_ACCOUNT, updateAccountSaga)
    yield takeLatest(DELETE_ACCOUNT, deleteAccountSaga)
}
